var TAhero = (function($) {
    'use strict';

    function equalizeColumnHeights() {
        if ($(window).width() >= 1280) {
            const twoColumnHero = $('.sec--hero.two-column');
            
            if (twoColumnHero.length) {
                const copyElements = twoColumnHero.find('.wrapper__copy');
                let maxHeight = 0;

                // Reset heights first
                copyElements.css('height', 'auto');

                // Find the tallest element
                copyElements.each(function() {
                    const height = $(this).outerHeight();
                    maxHeight = Math.max(maxHeight, height);
                });

                // Apply the height to all elements
                copyElements.css('height', maxHeight + 'px');
            }
        } else {
            // Reset heights when below breakpoint
            $('.sec--hero.two-column .wrapper__copy').css('height', 'auto');
        }
    }

    function init() {
        events();
        equalizeColumnHeights();

        // Re-run on window resize
        $(window).on('resize', function() {
            equalizeColumnHeights();
        });
    }

    function events() {

    }

    return {
        init:init
    };
}(jQuery));